/** @format */

import { CategoryChildVO } from './category-child-vo.interface';
import { ProductListSEO } from '@shared/data-access/interfaces';

// Mapped from `ProductListSEO` in {@link CategoryContainerComponent#handleCategoryData}
export interface CategorySEOData extends ProductListSEO {
  childVOs?: CategoryChildVO[];
}
